import AirPump from '@/components/UI/svg/trail-series/AirPump';
import Camera from '@/components/UI/svg/trail-series/Camera';
import Drone from '@/components/UI/svg/trail-series/Drone';
import ElectricCooler from '@/components/UI/svg/trail-series/ElectricCooler';
import FishFinder from '@/components/UI/svg/trail-series/FishFinder';
import GameConsole from '@/components/UI/svg/trail-series/GameConsole';
import LEDStrip from '@/components/UI/svg/trail-series/LEDStrip';
import PortableProjector from '@/components/UI/svg/trail-series/PortableProjector';
import Speaker from '@/components/UI/svg/trail-series/Speaker';
import Tablet from '@/components/UI/svg/trail-series/Tablet';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoTab from 'eco-design/elements/eco-tab';
import EFFan from 'elem/ui-assets/icons/appliances/EFFan';
import EFLaptop from 'elem/ui-assets/icons/appliances/EFLaptop';
import EFLight from 'elem/ui-assets/icons/appliances/EFLight';
import EFPhone from 'elem/ui-assets/icons/appliances/EFPhone';
import EFWiFi from 'elem/ui-assets/icons/appliances/EFWiFi';
import { useState } from 'react';
import Modal from './components/Modal';
import TableList from './components/TableList';
import styles from './index.module.scss';

import { useGlobal } from '@/utils/useGlobal';
import gtm from '@/utils/gtm';
import { config } from './config';
import getLocal from '@/app/utils/i18n';

export default function TabSwriper() {
    const { useLang } = useGlobal();
    const { locale } = getLocal();
    const { t } = useLang('TrailSeries.tabSwriper');
    const [activeTab, setActiveTab] = useState(t('tab_title1'));
    const [activeIndex, setActiveIndex] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const ModalIcon = () => (
        <svg width="37" height="36" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" width="36" height="36" rx="18" fill="url(#paint0_linear_3253_2898)" />
            <path d="M25.7833 18.0001H11.2167" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M18.5 10.7168V25.2834" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            <defs>
                <linearGradient id="paint0_linear_3253_2898" x1="0.500005" y1="4.80002" x2="27.1868" y2="-1.77879" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#3F68E0" />
                    <stop offset="1" stopColor="#7D9DFC" />
                </linearGradient>
            </defs>
        </svg>
    );

    const Tabs =
        locale === 'ph'
            ? config().tabs
            : [
                  {
                      title: t('tab_title1'),
                      items: [
                          { name: t('tab_item1_name1'), times: t('tab_item1_time1'), icon: <EFLight /> },
                          { name: t('tab_item1_name2'), times: t('tab_item1_time2'), icon: <PortableProjector /> },
                          { name: t('tab_item1_name3'), times: t('tab_item1_time3'), icon: <AirPump /> },
                          { name: t('tab_item1_name4'), times: t('tab_item1_time4'), icon: <EFWiFi /> },
                      ],
                      pc: 'https://websiteoss.ecoflow.com/upload/image/1753952902670/300_5%202%201.jpg',
                      pad: 'https://websiteoss.ecoflow.com/upload/image/1753952902758/300_5%202%201%20(1).jpg',
                      h5: 'https://websiteoss.ecoflow.com/upload/image/1753952903087/300_5%202%201%20(2).jpg',
                  },
                  {
                      title: t('tab_title2'),
                      items: [
                          { name: t('tab_item2_name1'), times: t('tab_item2_time1'), icon: <EFPhone /> },
                          { name: t('tab_item2_name2'), times: t('tab_item2_time2'), icon: <Camera /> },
                          { name: t('tab_item2_name3'), times: t('tab_item2_time3'), icon: <Drone /> },
                          { name: t('tab_item2_name4'), times: t('tab_item2_time4'), icon: <EFLight /> },
                      ],
                      pc: 'https://websiteoss.ecoflow.com/upload/image/1753669933049/tab_pc_2.png',
                      pad: 'https://websiteoss.ecoflow.com/upload/image/1753669932070/tab_pad_2.png',
                      h5: 'https://websiteoss.ecoflow.com/upload/image/1753669932683/tab_h5_2.png',
                  },
                  {
                      title: t('tab_title3'),
                      items: [
                          { name: t('tab_item3_name1'), times: t('tab_item3_time1'), icon: <LEDStrip /> },
                          { name: t('tab_item3_name2'), times: t('tab_item3_time2'), icon: <Speaker /> },
                          { name: t('tab_item3_name3'), times: t('tab_item3_time3'), icon: <PortableProjector /> },
                          { name: t('tab_item3_name4'), times: t('tab_item3_time4'), icon: <ElectricCooler /> },
                      ],
                      pc: 'https://websiteoss.ecoflow.com/upload/image/1753669929887/tab_pc_3.png',
                      pad: 'https://websiteoss.ecoflow.com/upload/image/1753669931684/tab_pad_3.png',
                      h5: 'https://websiteoss.ecoflow.com/upload/image/1753669929599/tab_h5_3.png',
                  },
                  {
                      title: t('tab_title4'),
                      items: [
                          { name: t('tab_item4_name1'), times: t('tab_item4_time1'), icon: <EFFan /> },
                          { name: t('tab_item4_name2'), times: t('tab_item4_time2'), icon: <EFLight /> },
                          { name: t('tab_item4_name3'), times: t('tab_item4_time3'), icon: <FishFinder /> },
                          { name: t('tab_item4_name4'), times: t('tab_item4_time4'), icon: <ElectricCooler /> },
                      ],
                      pc: 'https://websiteoss.ecoflow.com/upload/image/1753669931075/tab_pc_4.png',
                      pad: 'https://websiteoss.ecoflow.com/upload/image/1753669933668/tab_pad_4.png',
                      h5: 'https://websiteoss.ecoflow.com/upload/image/1753669930174/tab_h5_4.png',
                  },
                  {
                      title: t('tab_title5'),
                      items: [
                          { name: t('tab_item5_name1'), times: t('tab_item5_time1'), icon: <Tablet /> },
                          { name: t('tab_item5_name2'), times: t('tab_item5_time2'), icon: <EFLaptop /> },
                          { name: t('tab_item5_name3'), times: t('tab_item5_time3'), icon: <EFWiFi /> },
                          { name: t('tab_item5_name4'), times: t('tab_item5_time4'), icon: <GameConsole /> },
                      ],
                      pc: 'https://websiteoss.ecoflow.com/upload/image/1753669930749/tab_pc_5.png',
                      pad: 'https://websiteoss.ecoflow.com/upload/image/1753669930439/tab_pad_5.png',
                      h5: 'https://websiteoss.ecoflow.com/upload/image/1753669931314/tab_h5_5.png',
                  },
              ];

    const TabItems = Tabs.map((item) => ({ tabValue: item.title, tabLabel: item.title }));

    const onTabChange = (item: any, index: number) => {
        setActiveTab(item.tabValue);
        setActiveIndex(index);
    };

    const handleOpenModal = () => {
        setIsModalOpen(true);
        gtm.push({
            event: 'uaEvent',
            event_name: 'product_details',
            tab: t('title'),
            button_name: t('checkTimesButton'),
            __btn_id1: `${styles.TabSwriper} .check-times-btn`,
            __btn_id2: t('checkTimesButton'),
            __btn_type: 'text',
        });
    };

    return (
        <div className={`page-tabSwriper ${styles.TabSwriper} GtmModuleData-section`} data-section-id="TabSwriper" id="TabSwriper">
            <EcoSectionCommon title={t('title')} desc={t('desc')} />
            <EcoSpaceSmall />
            <div className={`eco-content ${styles.TabSwriper}`}>
                <div className="tab-container">
                    <div className="tab-wrapper">
                        <div className="content-image">
                            <EcoImg pc={Tabs[activeIndex].pc} pad={Tabs[activeIndex].pad} h5={Tabs[activeIndex].h5} />
                        </div>
                        <div className="tab-content">
                            <div className="content-items">
                                {Tabs[activeIndex].items.map((item, index) => (
                                    <div key={index} className="item">
                                        <div className="item-icon">{item.icon}</div>
                                        <div className="item-info">
                                            <div className="item-times">{item.times}</div>
                                            <div className="item-name">{item.name}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="tab-headers">
                        <EcoTab activeKey={activeTab} gtmTitle={t('title')} items={TabItems} onChange={onTabChange} />
                    </div>
                </div>
                <button className="check-times-btn GtmModuleData-btn-text" onClick={() => handleOpenModal()}>
                    {t('checkTimesButton')}
                    <span className="more-icon">
                        <ModalIcon />
                    </span>
                </button>
                <div className="note">{t('note')}</div>
            </div>
            <Modal visible={isModalOpen} onClose={() => setIsModalOpen(false)}>
                <TableList />
            </Modal>
        </div>
    );
}
